import * as _Int from "../settings/interfaces";

export let entries: _Int.Store.ISelection[] = [];

/**
 * Adds and records a new page entry.
 * @param cardInfo Card info.
 * @param direction Direction swiped.
 */
export function addEntry(cardInfo: _Int.Path.ICard, direction: string): void {

  let nextCard: string = "";

  switch (direction) {
    case "left":
      nextCard = cardInfo.rightCard as string;
      break;
    case "right":
      nextCard = cardInfo.leftCard as string;
      break;
    case "top":
      nextCard = cardInfo.bottomCard as string;
      break;
    case "bottom":
      nextCard = cardInfo.topCard as string;
      break;
  }

  // log user entry
  const newChoice: _Int.Store.ISelection = {
    id: cardInfo.id,
    direction,
    nextCard
  };

  if (cardInfo.set as number >= 0) {
    newChoice.setGroup = cardInfo.set;
  }

  entries.push(newChoice);

}

/**
 * Clears the current log entries.
 */
export function clear(): void {

  entries = [];

}